module.exports = __webpack_public_path__ + "media/images/thumbs/fileassignment/ohap_assignments_file-bf073a25c40a55c7d232b705e500a2a2.png";